import {Component, Input} from '@angular/core';
import {TopSalesStore} from "./store/top-sales-store";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {CurrencyPipe, KeyValuePipe} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";

@Component({
  selector: 'app-top-sales',
  templateUrl: './top-sales.component.html',
  styleUrls: ['./top-sales.component.css'],
  // CommonModule dropped with the last `*ngFor`/`[ngClass]` (CLAUDE.md rule 6); only the two pipes the
  // template still uses are imported.
  imports: [
    FormsModule,
    CurrencyPipe,
    KeyValuePipe,
    ErrorMessageComponent
  ],
  providers: [TopSalesStore]
})
export class TopSalesComponent {
  @Input() hideMenu: boolean = true;
  protected readonly ErrorCodes = ErrorCodes;

  constructor(public topSalesStore: TopSalesStore) {
  }
}
